export enum SampleRetentionAnnex {
    YES = 'Yes',
    NO = 'No',
    NA = 'N/A'
} 